import { NoParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/languages'

interface Endpoints {
  getLanguages: NoParamEndpointConstructor
}

export const languagesEndpoints: Endpoints = {
  getLanguages: () => baseUrl,
}
